import { lazy } from 'react';

const Home = lazy(() => import('./home'));

export default Home;
